<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter">
<p class="lined"></p>
<p class="fm1"><span epub:type="pagebreak" id="page_xvi" title="xvi"><i>To the eyes of an outsider, the initial impression of ancient Egypt is one of unfamiliarity</i>.</span></p>
<p class="fm2">—<b>JAROMIR MALEK</b>, <i>In the Shadow of the Pyramids</i>: <i>Egypt during the Old Kingdom</i></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Frontmatter03.vue?2805a6c8